import { useRef, useState } from 'react';

/** Offline-capable freehand sketch that becomes a normal evidence image when saved. */
export function MudMapCanvas({ onSave }: { onSave(file: File): void }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const [hasDrawing, setHasDrawing] = useState(false);

  function point(event: React.PointerEvent<HTMLCanvasElement>) {
    const canvas = canvasRef.current!;
    const rect = canvas.getBoundingClientRect();
    return { x: (event.clientX - rect.left) * (canvas.width / rect.width), y: (event.clientY - rect.top) * (canvas.height / rect.height) };
  }
  function start(event: React.PointerEvent<HTMLCanvasElement>) {
    const context = canvasRef.current!.getContext('2d')!;
    const { x, y } = point(event);
    drawing.current = true;
    event.currentTarget.setPointerCapture(event.pointerId);
    context.beginPath(); context.moveTo(x, y);
  }
  function draw(event: React.PointerEvent<HTMLCanvasElement>) {
    if (!drawing.current) return;
    const context = canvasRef.current!.getContext('2d')!;
    const { x, y } = point(event);
    context.lineWidth = 3; context.lineCap = 'round'; context.strokeStyle = '#152238';
    context.lineTo(x, y); context.stroke(); setHasDrawing(true);
  }
  function stop() { drawing.current = false; }
  function clear() {
    const canvas = canvasRef.current!;
    canvas.getContext('2d')!.clearRect(0, 0, canvas.width, canvas.height);
    setHasDrawing(false);
  }
  function save() {
    canvasRef.current?.toBlob((blob) => {
      if (blob) onSave(new File([blob], `mud-map-${new Date().toISOString().slice(0, 10)}.png`, { type: 'image/png' }));
    }, 'image/png');
  }

  return <div className="mud-map-canvas"><p className="form-help">Draw a simple site sketch, treatment/finding locations and north orientation. It is saved as linked evidence and can be annotated below.</p><canvas id="termiteMudMapCanvas" ref={canvasRef} width={1200} height={700} aria-label="Mud map drawing canvas" onPointerDown={start} onPointerMove={draw} onPointerUp={stop} onPointerCancel={stop} /><div className="form-actions"><button type="button" onClick={clear}>Clear sketch</button><button type="button" className="btn-primary" disabled={!hasDrawing} onClick={save}>Add sketch to mud-map evidence</button></div></div>;
}
